export default function Privacy({ setPage }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-blue-50 to-white px-4 py-16">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-sm p-8 md:p-12">

        <button
          onClick={() => setPage("landing")}
          className="text-sm text-indigo-600 hover:underline mb-8"
        >
          ← Volver
        </button>

        <h1 className="text-3xl font-bold mb-8">Política de Privacidad</h1>

        <section className="space-y-6 text-gray-700">
          <p>
            En Biajando respetamos tu privacidad. No recopilamos datos
            personales sensibles ni almacenamos información de pago.
          </p>

          <p>
            La información que el usuario proporciona (por ejemplo, preferencias
            de viaje) se utiliza únicamente para generar propuestas orientativas
            y responder a las solicitudes realizadas.
          </p>

          <p>
            La comunicación principal se realiza a través de WhatsApp o correo
            electrónico, utilizando las plataformas correspondientes y sus
            medidas de seguridad.
          </p>

          <p>
            No compartimos datos personales con terceros con fines comerciales
            ni publicitarios.
          </p>
        </section>

      </div>
    </div>
  );
}
